import type { Environment } from "../types";

export default {
    name: "prod",
    apiGatewayBaseUrl: import.meta.env.VITE_API_GATEWAY_BASE_URL,
    identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
    s3BucketName: import.meta.env.VITE_S3_BUCKET_NAME,
    userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    userPoolId: import.meta.env.VITE_USER_POOL_ID,
} satisfies Environment;
